import Layout from '@/layout/layout'

const RecallOrderRouter = {
    path: '/RecallOrder',
    component: Layout,
    redirect: 'noRedirect',
    name: '回收订单管理',
    children: [
        {
            path: 'index',
            component: () => import('@/views/RecallOrder/index'),
            name: '订单列表',
            meta: {title: '订单列表', noCache: true}
        },
        {
            path: 'Details',
            component: () => import('@/views/RecallOrder/Details'),
            name: '订单详情',
            meta: {title: '订单详情', noCache: true}
        },
        {
            path: "evaluate",
            component: () => import("@/views/RecallOrder/evaluate.vue"),
            name: "估价单",
            meta: {title: "估价单", noCache: true}
        },
        {
            path: "ImportOrder",
            component: () => import("@/views/RecallOrder/ImportOrder/index.vue"),
            name: "外部订单手工退单",
            meta: {title: "外部订单手工退单", noCache: true}
        },
        {
            path: 'failedBidorder',
            component: () => import('@/views/RecallOrder/failedBidorder/index'),
            name: '竞价失败订单',
            meta: {title: '竞价失败订单', noCache: true}
        },
        {
            path: 'rejuectOrder',
            component: () => import('@/views/RecallOrder/rejuectOrder/index'),
            name: '报价单',
            meta: {title: '报价单', noCache: true}
        },
        {
            path: 'negotiatedOrder',
            component: () => import('@/views/RecallOrder/negotiatedOrder/index'),
            name: '议价订单',
            meta: {title: '议价订单', noCache: true}
        },
        {
            path: 'LowMachineMapRecord',
            component: () => import('@/views/RecallOrder/LowMachineMapRecord/index'),
            name: '低端机识图记录',
            meta: {title: '低端机识图记录', noCache: true}
        },
        {
            path: 'masterSlaveMerchantOrder',
            component: () => import('@/views/RecallOrder/masterSlaveMerchantOrder/index'),
            name: '主从商户订单关联记录',
            meta: {title: '主从商户订单关联记录', noCache: true}
        },
        {
            path: 'autoOrder',
            component: () => import('@/views/RecallOrder/autoOrder/index'),
            name: '智能报价单',
            meta: {title: '智能报价单', noCache: true}
        },
        {
            path: 'banAccount',
            component: () => import('@/views/RecallOrder/banAccount/index'),
            name: '禁用账号管理',
            meta: { title: '禁用账号管理', noCache: true }
        },
            {
            path: 'imageRecog',
            component: () => import('@/views/RecallOrder/imageRecog/index'),
            name: 'AI识图详情',
            meta: {title: 'AI识图详情', noCache: true}
        },
    ]
}

export default RecallOrderRouter
